/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="95.58" height="95.58" viewBox="0 0 95.58 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <g>
      <path d="M77.29,29.5a47.79,47.79,0,1,0,47.79,47.79A47.85,47.85,0,0,0,77.29,29.5Zm0,2.5A45.29,45.29,0,1,1,32,77.29,45.35,45.35,0,0,1,77.29,32Z" transform="translate(-29.5 -29.5)" fill="#0e497b"/>
      <path d="M77.29,74.17a3.13,3.13,0,1,0,3.13,3.12,3.12,3.12,0,0,0-3.13-3.12" transform="translate(-29.5 -29.5)" fill="#0e497b" fillRule="evenodd"/>
      <path d="M77.29,72.92a4.38,4.38,0,1,0,4.38,4.37A4.37,4.37,0,0,0,77.29,72.92Zm0,2.5a1.88,1.88,0,1,1-1.87,1.87A1.88,1.88,0,0,1,77.29,75.42Z" transform="translate(-29.5 -29.5)" fill="#0e497b"/>
      <path d="M77.29,37a1.26,1.26,0,0,1,1.25,1.12V48.39a1.25,1.25,0,0,1-2.49.13V38.28A1.25,1.25,0,0,1,77.29,37Z" transform="translate(-29.5 -29.5)" fill="#ffb81c"/>
      <path d="M48.93,48.93a1.24,1.24,0,0,1,1.67-.09l.1.09,7,7a1.25,1.25,0,0,1-1.67,1.86l-.1-.09-7-7A1.25,1.25,0,0,1,48.93,48.93Z" transform="translate(-29.5 -29.5)" fill="#ffb81c"/>
      <path d="M48.39,76a1.25,1.25,0,0,1,.13,2.5H38.28a1.25,1.25,0,0,1-.13-2.49H48.39Z" transform="translate(-29.5 -29.5)" fill="#ffb81c"/>
      <path d="M56,96.82a1.27,1.27,0,0,1,1.77,0,1.24,1.24,0,0,1,.09,1.67l-.09.1-7.16,7.16a1.24,1.24,0,0,1-1.76,0,1.26,1.26,0,0,1-.1-1.67l.1-.1Z" transform="translate(-29.5 -29.5)" fill="#ffb81c"/>
      <path d="M77.29,105.19a1.26,1.26,0,0,1,1.25,1.12v10a1.25,1.25,0,0,1-2.49.13v-10A1.25,1.25,0,0,1,77.29,105.19Z" transform="translate(-29.5 -29.5)" fill="#ffb81c"/>
      <path d="M96.83,96.83a1.27,1.27,0,0,1,1.67-.09l.1.09,7.15,7.15a1.25,1.25,0,0,1,0,1.77,1.27,1.27,0,0,1-1.67.09l-.1-.09L96.83,98.6A1.27,1.27,0,0,1,96.83,96.83Z" transform="translate(-29.5 -29.5)" fill="#ffb81c"/>
      <path d="M116.3,76a1.25,1.25,0,0,1,.13,2.5H106.19a1.25,1.25,0,0,1-.13-2.49H116.3Z" transform="translate(-29.5 -29.5)" fill="#ffb81c"/>
      <path d="M104,48.84a1.25,1.25,0,0,1,1.86,1.66l-.09.1L98.6,57.75a1.25,1.25,0,0,1-1.77,0,1.27,1.27,0,0,1-.09-1.67l.09-.1Z" transform="translate(-29.5 -29.5)" fill="#ffb81c"/>
      <path d="M89.11,45.64a1.25,1.25,0,0,1,2.36.84l0,.12-13,31.17a1.26,1.26,0,0,1-1.52.72l-.12,0-21.67-9A1.25,1.25,0,0,1,56,67.12l.12,0,20.52,8.5Z" transform="translate(-29.5 -29.5)" fill="#0e497b"/>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'ClockIcon';

export default Icon;
